(function ($) {
    'use strict';

    var adios = {};


    window.init_adios = function(
            async_proxy_url,
            endpoint_map,
            account_id) {
        var THROBBER_CONTAINER  = '.user-data-protection_throbber';

        adios.callEndpoint = function (settings) {
            settings.endpoint = endpoint_map[settings.endpoint];
            settings.asyncResultEndpoint = async_proxy_url;
            settings.accountId = account_id;
            settings.asyncResultHandler = function (data) {
                switch (parseInt(data.status)) {
                    case 200: // Success
                        return wg_ui.ENDPOINT_RESULT_SUCCESS;
                    default:
                        return wg_ui.ENDPOINT_RESULT_FAILURE
                }
            };
            return wg_ui.callEndpoint(settings);
        };

        adios.suspendAccount = function () {
            wg_modal.showThrobber($(THROBBER_CONTAINER), true);

            var data = {
                account_id: account_id
            };

            this.callEndpoint({
                endpoint: "suspend",
                data: data,
                success: function () {
                    wg_modal.hideThrobber();
                    document.location = '?completed';
                },
                failure: null // default handler will show error and hide throbber
            });
        };

        adios.unsuspendAccount = function () {
            wg_modal.showThrobber($(THROBBER_CONTAINER), true);

            var data = {
                account_id: account_id
            };

            this.callEndpoint({
                endpoint: "unsuspend",
                data: data,
                success: function () {
                    wg_modal.hideThrobber();
                    document.location = '?completed';
                },
                failure: null // default handler will show error and hide throbber
            });
        };
        return adios;
    };
})(jQuery);
